import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';

const initialState = {
  sample: {},
  error: null,
  status: 'idle',
  updateStatus: 'idle',
  updateError: null,
};

export const fetchSample = createAsyncThunk(
  'fetch-sample',
  async ({ searchKeyword }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`super-admin/sample/${searchKeyword}`);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.msg);
    }
  }
);

export const updateRecommendation = createAsyncThunk(
  '/update-report-recommendation',
  async ({ id }, { rejectWithValue }) => {
    console.log('sample ID: ', id);
    try {
      const { data } = await axiosInstance.get(`/recommendation/update/${id}`);
      console.log('update recommendation: ', data);
    } catch (err) {
      return rejectWithValue(err.response.data.msg);
    }
  }
);

export const updateSampleAndReport = createAsyncThunk(
  'update-sampleandreport',
  async ({ values }, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.put(`/super-admin/update-sample-report`, {
        ...values,
      });
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.msg);
    }
  }
);

export const sampleSlice = createSlice({
  name: 'sample',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchSample.pending, (state, action) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchSample.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.sample = { ...action.payload };
      })
      .addCase(fetchSample.rejected, (state, action) => {
        state.status = 'failed';
        state.sample = {};
        state.error = action.payload || 'An error occured';
      })
      .addCase(updateSampleAndReport.pending, (state, action) => {
        state.updateStatus = 'loading';
        state.updateError = null;
      })
      .addCase(updateSampleAndReport.fulfilled, (state, action) => {
        state.updateStatus = 'succeeded';
        state.sample = { ...action.payload };
        alert('Updated successfully!');
      })
      .addCase(updateSampleAndReport.rejected, (state, action) => {
        state.updateStatus = 'failed';
        state.sample = {};
        state.error = action.payload || 'An error occured';
      });
  },
});

export default sampleSlice.reducer;
